import React from 'react';
import Modal from '../../shared/modal';
import TeamTable from './TeamTable';


interface ITeamsModal {
    openModal: boolean;
    status?: any;
    handleCloseModal: () => void;
    SuccessfullyDeleted: () => void;
}

const TeamsModal = ({
    openModal,
    status,
    handleCloseModal,
    SuccessfullyDeleted
}: ITeamsModal) => {

    const onCloseModal = () => {
        handleCloseModal();
    }

    return (
        <Modal
            open={openModal}
            onClose={onCloseModal}
            contentContainerStyle={'!rounded-xl min-w-[95%] md:min-w-[70%] lg:min-w-[60%]'}>
            <div className={'p-2 min-w-[95%] md:min-w-[70%] lg:min-w-[60%] min-h-[500px] '}>
                <p className='mb-2 font-semibold text-sm dark:text-primary-dark'>Team </p>
                <p className='mb-4 text-sm dark:text-primary-dark'>Select role you want to assign to this user.</p>
                <div>
                    <TeamTable
                        status={status}
                        onCloseModal={onCloseModal}
                        SuccessfullyDeleted={SuccessfullyDeleted}
                    />
                </div>
            </div>
        </Modal >
    )
}
export default TeamsModal;